import { Route, Routes } from 'react-router-dom'
import { RodizioDeVendas } from '../pages/Vendas/RodizioDeVendas'
import { FilaLayout } from '../pages/Vendas/FilaLayout'
import { SolicitarRetificacao } from '../pages/Vendas/SolicitarRetificacao'
import { VisualizarCanhoto } from '../pages/Vendas/VisualizarCanhoto'
import { DescontoVendedor } from '../pages/Vendas/DescontoVendedor'
import { MeusLayouts } from '../pages/Vendas/MeusLayouts'
import { ControleDeFila } from '../pages/Vendas/ControleDeFila'
import { LiberacaoCartaoRecusado } from '../pages/Vendas/LiberacaoCartaoRecusado'
import { NovoOrcamentoPedido } from '../pages/Vendas/NovoOrcamentoPedido'
import { OrcamentoPedidoProvider } from '../contexts/OrcamentoPedidoProvider'
import { GerarPedido } from '../pages/Vendas/GerarPedido'
import { BuscarProposta } from '../pages/Vendas/NovoOrcamentoPedido/BuscarProposta'
import { Clientes } from '../pages/Vendas/Clientes'
import { ClientesSemVendedor } from '../pages/Vendas/ClientesSemVendedor'
import { AlteracaoLayoutManual } from '../pages/Vendas/AlteracaoLayoutManual'
import { PedidosNegados } from '../pages/Vendas/PedidosNegados'
import { CadastroRapidoEventos } from '../pages/Vendas/CadastroRapidoEvento'
import { ResetarCompreGanhe } from '../pages/Vendas/ResetarCompreGanhe'
import { MensagensAgendadas } from '../pages/Vendas/MensagensAgendadas'

export function RouteVendas() {
  return (
    <Routes>
      <Route path="/rodizio-vendas" element={<RodizioDeVendas />} />
      <Route path="/fila-layout" element={<FilaLayout />} />
      <Route path="/solicitar-retificacao" element={<SolicitarRetificacao />} />
      <Route path="/visualizar-canhoto" element={<VisualizarCanhoto />} />
      <Route path="/desconto-vendedor" element={<DescontoVendedor />} />
      <Route path="/meus-layouts" element={<MeusLayouts />} />
      <Route path="/controle-de-fila" element={<ControleDeFila />} />
      <Route path="/liberacao-cartao-recusado" element={<LiberacaoCartaoRecusado />} />
      {/* <Route
        path="orcamento-pedido"
        element={
          <OrcamentoPedidoProvider>
            <NovoOrcamentoPedido />
          </OrcamentoPedidoProvider>
        }
      /> */}
      <Route path="/gerar-pedido/:pedido" element={<GerarPedido />} />
      <Route path="/orcamento-pedido" element={<BuscarProposta />} />
      <Route
        path="orcamento-pedido/:numeroProposta"
        element={
          <OrcamentoPedidoProvider>
            <NovoOrcamentoPedido />
          </OrcamentoPedidoProvider>
        }
      />
      <Route path="/clientes" element={<Clientes />} />
      <Route path="/clientes-sem-vendedor" element={<ClientesSemVendedor />} />
      <Route path="/alteracao-layout-manual" element={<AlteracaoLayoutManual />} />
      <Route path="/pedidos-negados" element={<PedidosNegados />} />
      <Route path="/cadastro-rapido-evento" element={<CadastroRapidoEventos />} />
      <Route path="/resetar-compre-ganhe" element={<ResetarCompreGanhe />} />
      <Route path="/mensagens-agendadas" element={<MensagensAgendadas />} />
    </Routes>
  )
}
